module.exports = __webpack_public_path__ + "static/media/01-galeria-02-bottega-venetta-mobile@2x.63b9335d.jpg";